/*
 * @Copyright: 中国信息安全测评中心
 * @Author: xiaowenwen
 * @Date: 2021-03-02 11:50:32
 * @LastEditTime: 2023-02-01 16:36:28
 * @Description:
 */
const TASK_STATE_DATA = [
  {
    key: "Waiting",
    value: 0,
    text: "等待"
  },
  {
    key: "Running",
    value: 100,
    text: "执行中"
  },
  {
    key: "Success",
    value: 200,
    text: "执行成功"
  },
  {
    key: "QuotaOver",
    value: 201,
    text: "账号已满"
  },
  {
    key: "Canceled",
    value: 300,
    text: "用户取消"
  },
  {
    key: "CircuitBreaker",
    value: 301,
    text: "熔断保护"
  },
  {
    key: "ProgramError",
    value: 400,
    text: "程序执行异常中断"
  },
  {
    key: "LdapError",
    value: 401,
    text: "LDAP连接异常中断"
  },
  {
    key: "NeteaseError",
    value: 402,
    text: "网易连接异常中断"
  },
  {
    key: "UnknownError",
    value: 500,
    text: "未知原因中断"
  },
  {
    key: "AccountExist",
    value: 202,
    text: "部分账号已存在"
  },
  {
    key: "DomainNoExist",
    value: 203,
    text: "部分域名不存在"
  },
  {
    key: "Diskspacefull",
    value: 204,
    text: "磁盘空间不足"
  }
];
const TASK_STATE = {};
const TASK_STATE_TEXT = {};
for (let item of TASK_STATE_DATA) {
  TASK_STATE[item.key] = item.value;
  TASK_STATE_TEXT[item.value] = item.text;
}
export { TASK_STATE, TASK_STATE_TEXT };
